/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import '@hems/component/resources/scss/main.scss';
const SmartModuleMobileHome = () => import(/* webpackChunkName: "SmartModuleMobileHome" */ '@/mobileviews/smartmodule/SmartModuleMobileHome.vue');
const SmartModuleMobileHomeDemo = () => import(/* webpackChunkName: "SmartModuleMobileHomeDemo" */ '@/mobileviews/smartmodule/SmartModuleMobileHomeDemo.vue');
const mobileRoutes = [
    {
        path: '/mobile/smartmodule/',
        name: 'SmartModuleMobileHome',
        component: SmartModuleMobileHome,
    },
    {
        path: '/mobile/smartmodule/demo',
        name: 'SmartModuleMobileHomeDemo',
        component: SmartModuleMobileHomeDemo,
    },
];
export default mobileRoutes;
